<template>
  <div v-if="!loading" class="user-page">
    <div class="heading"><strong>{{ $route.params.id }}'s</strong> prompts</div>

    <template v-if="userPrompts.length">
      <table class="prompts">
        <thead>
          <tr>
            <th class="username">Fandom</th>
            <th class="characters">Characters</th>
            <th class="prompts">Prompts</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(prompt, i) in userPrompts" :key="i">
            <td>
              {{ prompt.fandom }}
            </td>
            <td>
              <ul v-if="prompt.characters" class="characters">
                <li v-for="(c, i) in prompt.characters" :key="i">{{ c }}</li>
              </ul>
            </td>
            <td class="prompt">
              <div v-html="prompt.prompt"></div>
              <a v-if="prompt.letter" :href="formatUrl(prompt.letter)" target="blank">Letter</a>
            </td>
          </tr>
        </tbody>
      </table>
    </template>
    <div v-else>User not found! Search is case-sensitive and preserves whitespace - maybe check your search and try again?.</div>

  </div>
  <div v-else>Loading {{ $route.params.id }}'s prompts...</div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import utils from './components/utils.js';
  export default {
    async beforeMount() {
      await this.getUserPrompts(this.$route.params.id);
      this.loading = false;
    },
    watch: {
      async $route(to, from) {
        this.loading = true;
        await this.getUserPrompts(this.$route.params.id);
         this.loading = false;
      }
    },
    data() {
      return {
        loading: true
      }
    },
    computed: {
      ...mapGetters([
        'userPrompts',
        'options'
      ])
    },
    methods: {
      ...utils
    }
  };
</script>


<style lang="scss">
@import './styles/app.scss';
@import './styles/mobile.scss';

.user-page {
  min-width: 480px;
  width: 90%;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// User.vue?debb2f80